module.exports = __webpack_public_path__ + "static/media/screenshot_empty.dc2ac617.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshot_empty.png
// module id = 81
// module chunks = 0